module.exports = __webpack_public_path__ + "static/Cherry_Clark_at_Mosser.d3ed940a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/art-in-neighborhoods/Cherry_Clark_at_Mosser.jpg
// module id = 471
// module chunks = 107818501498521